import { useEffect, useMemo, useState } from 'react';
import { ListarIncidenciasPorRonda } from '../../../services/api';
import MapaBase from './MapaBase';
import { useAuth } from '../../../context/AuthContext';
import { estadoIncidencias, nivelIncidencia, peDate, peTime, tipoIncidencia } from '../../../util/util';
import { Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// import iconAltoPng from '../../../assets/nivelIncidencia/incidencia_alto.png';
// import iconMedioPng from '../../../assets/nivelIncidencia/incidencia_medio.png';
// import iconBajoPng from '../../../assets/nivelIncidencia/incidencia_bajo.png';
import EvidenciasPorIncidencias from './EvidenciasPorIncidencias';
import { iconAltoPng, iconMedioPng, iconBajoPng } from '../../../util/util';

export default function IncidenciasPorRonda({ round, assignment, pointControls }) {
  const { token } = useAuth();
  const [listIncidencias, setListIncidencias] = useState([]);
  const [selectedIncident, setSelectedIncident] = useState(null);
  const [showEvidenceModal, setShowEvidenceModal] = useState(false);

  useEffect(() => {
    const leerServicios = async () => {
      if (!round?.id) {
        setListIncidencias([]);
        return;
      }
      console.log(round)
      try {
        const data = await ListarIncidenciasPorRonda({ roundId: String(round.id), token });
        console.log("IncidenciasporRonda")
        console.log(data)
        setListIncidencias(Array.isArray(data) ? data : []);
        console.log(listIncidencias)



      } catch (error) {
        console.error('Error al cargar incidencias por ronda:', error);
        setListIncidencias([]);
      }

    };

    leerServicios();
  }, [round?.id, token]);

  const iconBajo = useMemo(
    () => L.icon({ iconUrl: iconBajoPng, iconSize: [32, 32], iconAnchor: [16, 32], popupAnchor: [0, -28] }),
    []
  );
  const iconMedio = useMemo(
    () => L.icon({ iconUrl: iconMedioPng, iconSize: [32, 32], iconAnchor: [16, 32], popupAnchor: [0, -28] }),
    []
  );
  const iconAlto = useMemo(
    () => L.icon({ iconUrl: iconAltoPng, iconSize: [32, 32], iconAnchor: [16, 32], popupAnchor: [0, -28] }),
    []
  );

  const iconPorNivel = (level) => {
    if (level === 3) return iconAlto;
    if (level === 2) return iconMedio;
    return iconBajo;
  };

  const abrirModalEvidencias = (incident) => {
    setSelectedIncident(incident);
    setShowEvidenceModal(true);
  };

  const cerrarModalEvidencias = () => {
    setShowEvidenceModal(false);
    setSelectedIncident(null);
  };

  return (
    <>
      <section>
        <h1>Incidentes por ronda</h1>

        <div className="row">
          <div className="col-12">
            <MapaBase assignment={assignment} pointControls={pointControls}>
              {listIncidencias.map((inc, index) => {
                const lat = Number(inc.latitude);
                const lng = Number(inc.longitude);
                if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;

                return (
                  <Marker
                    key={inc.id ?? index}
                    position={[inc.latitude, inc.longitude]}
                    icon={iconPorNivel(inc.levelIncident)}
                  >
                    <Popup>
{/* 
                      <h6>
                        {index + 1}. {nivelIncidencia(inc.levelIncident)}
                      </h6>
                      <h6>{inc.description}</h6> */}

                      <div className="text-center">
                        <h5>{index + 1}.  {tipoIncidencia(inc.typeIncident)}</h5>
                        <p className="fs-6 text-muted">
                          {inc.description}
                        </p>
                      </div>
                    </Popup>
                  </Marker>
                );
              })}
            </MapaBase>
          </div>

          <div className="col-12">
            <div className="card shadow-sm h-100">
              <div className="card-header bg-white d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-2">
                <h5 className="mb-0">Detalle</h5>
                <div className="d-flex flex-wrap align-items-center gap-3">
                  Nivel:
                  <small className="d-flex align-items-center gap-1">
                    Bajo: <img src={iconBajoPng} alt="Bajo" width={22} height={22} />
                  </small>
                  <small className="d-flex align-items-center gap-1">
                    Medio: <img src={iconMedioPng} alt="Medio" width={22} height={22} />
                  </small>
                  <small className="d-flex align-items-center gap-1">
                    Alto: <img src={iconAltoPng} alt="Alto" width={22} height={22} />
                  </small>
                </div>
              </div>
              <div className="card-body p-0">
                {listIncidencias.length === 0 ? (
                  <div className="text-center text-muted py-5">Sin incidencias registradas</div>
                ) : (
                  <div className="table-responsive" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                    <table className="table table-sm table-hover mb-0 text-center">
                      <thead className="table-light position-sticky top-0" style={{ zIndex: 1 }}>
                        <tr>
                          <th>#</th>
                          <th>Descripcion</th>
                          <th>Tipo</th>
                          <th>Nivel</th>
                          <th>Emergencia</th>
                          <th>Fecha</th>
                          <th style={{ width: '15%' }}>Estado</th>
                          <th style={{ width: '20px', paddingRight: '20px' }}>Evidencia</th>
                        </tr>
                      </thead>
                      <tbody>
                        {listIncidencias.map((inc, index) => (
                          <tr key={inc.id ?? index}>
                            <td><small>{index + 1}</small></td>
                            <td><small>{inc.description}</small></td>
                            <td><small>{tipoIncidencia(inc.typeIncident)}</small></td>
                            <td>{nivelIncidencia(inc.levelIncident)}</td>
                            <td>{inc.isEmergency ? 'Si' : 'No'}</td>
                            <td>
                              <small>{peDate(inc.creationDate)} - {peTime(inc.creationDate)}</small>
                            </td>
                            <td>{estadoIncidencias[inc.state - 1]}</td>
                            <td>
                              <button
                                type="button"
                                className="btn btn-primary btn-sm"
                                onClick={() => abrirModalEvidencias(inc)}
                              >
                                Ver
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      <EvidenciasPorIncidencias
        incidencia={selectedIncident}
        show={showEvidenceModal}
        onClose={cerrarModalEvidencias}
      />

      <span className="d-none">round:{round?.id} yard:{assignment?.yardId}</span>
    </>
  );
}
